import styled from '@emotion/styled'

/**
 * FullCoverageCard — 시군구 isFullCoverage=true 일 때 노출하는 정적 카드.
 *
 * DongAccordion 과 동일 컨테이너 (white bg, border, radius 16) + 단일 row padding.
 * 펼침 없음, 본문 영역 없음.
 *
 * 적용 범위: 경기 isFullCoverage 시군구 (구리·부천·안양·의정부 등) — SiGunGuChildren 에서 분기.
 * 인천 isFullCoverage 는 DongAccordion + chip 패턴 유지 (피그마 17740:44638), 본 카드 미사용.
 */

export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #f5f5f6;
  border-radius: 16px;
  overflow: hidden;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 17px;
`

/** brand orange — DongAccordion 의 FullCoverageChip 색(#ff5626)과 통일 */
export const CheckIcon = styled.svg`
  flex-shrink: 0;
  color: #ff5626;
`

export const Label = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: #1b1c1d;
`
